import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetcher } from '../../../lib/api-fetcher';

export interface MySession {
  id: string;
  createdAt: string;
  updatedAt: string;
  expiresAt: string;
  ipAddress: string | null;
  userAgent: string | null;
  isCurrent: boolean;
}

const mySessionsKey = ['settings', 'sessions'] as const;

export function useMySessions() {
  return useQuery({
    queryKey: mySessionsKey,
    queryFn: () =>
      fetcher.get<MySession[]>('/staff/v1/sessions'),
  });
}

export function useRevokeMySession() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (sessionId: string) => fetcher.delete(`/staff/v1/sessions/${sessionId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: mySessionsKey });
    },
  });
}
